import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../../lib/axios';

export const useUnreadCount = () =>
  useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: async () => {
      const r = await axiosInstance.get('/company-notifications/unread-count');
      return r.data.data as { count: number };
    },
    refetchInterval: 30000,
  });

export const useNotifications = (params?: { is_read?: string; page?: number }) =>
  useQuery({
    queryKey: ['notifications', 'list', params],
    queryFn: async () => {
      const r = await axiosInstance.get('/company-notifications', { params });
      return r.data;
    },
  });

export const useMarkRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => axiosInstance.put(`/company-notifications/${id}/read`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
};

export const useMarkAllRead = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => axiosInstance.put('/company-notifications/read-all'),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
};
